import styled, {css} from "styled-components";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { JackpotThemeType } from "../../../../../../services/jackpots/jackpots.service.interface";
import {JACKPOT_WIDGET_LAYOUT} from "../../../../jackpot-widget.component";

export interface IJackpotWidgetClockBoxProps {
    className?: string;
    widgetWidth?: number;
    themeType: JackpotThemeType;
    layout: JACKPOT_WIDGET_LAYOUT;
    isDaily: boolean;
}

const handleClockBoxFontSize = (layout: JACKPOT_WIDGET_LAYOUT, widgetWidth: number): string => {
    switch (layout) {
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
            /** In landscape view at a widget width of 468px, the amount should be of font-size 30px */
            return widgetWidth ? (widgetWidth * 30 / 468 + "px") : "30px";
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
            /** In minimized view at a widget width of 375px, the amount should be of font-size 15px */
            return widgetWidth ? (widgetWidth * 15 / 375 + "px") : "15px";
        case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
        default:
            /** In portrait view at a widget width of 131px, the amount should be of font-size 15px */
            return widgetWidth ? (widgetWidth * 15 / 131 + "px") : "15px";
    }
};

const JackpotWidgetClockDefaultBox = styled.div<IJackpotWidgetClockBoxProps>`
    color: ${({theme}) => theme.colors.textLight};
    font-family: ${({theme}) => theme.components.jackpotWidget.font.clock};

    width: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "26%" : "100%" };
    text-align: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "right" : "center" };

    /** For the floating clock shown in game, no need to compute relative (fluid) font-size */
    font-size: ${({widgetWidth, layout}) => handleClockBoxFontSize(layout, widgetWidth)};
    /* bugfix: 2039067 */
    line-height: 1.0;
    padding-bottom: 0.5rem;
`;

const JackpotWidgetClockCasino777Box = styled(JackpotWidgetClockDefaultBox)`
    color: ${({themeType, theme}) => themeType === JackpotThemeType.Light ? theme.colors.brandPrimaryContrast : theme.colors.brandSecondary};
`;

const JackpotWidgetClockSiBox = styled(JackpotWidgetClockDefaultBox)`
    color: ${({theme}) => /* theme.colors.textContrast */ theme.colors.moneyColor };
`;

const JackpotWidgetClockMrGreenBox = styled(JackpotWidgetClockDefaultBox)`
    color: ${({theme}) => theme.colors.textDark };

    ${({isDaily}) => isDaily ? css`
      ${({theme}) => theme.font.presets.bold};
      font-weight: 600;
      padding-bottom: 0;
    ` : null};
`;

export const JackpotWidgetClockBox = styledByTheme(JackpotWidgetClockDefaultBox)
    .forCasino777(JackpotWidgetClockCasino777Box)
    .forSI(JackpotWidgetClockSiBox)
    .forSICis(JackpotWidgetClockSiBox)
    .forMrGreen(JackpotWidgetClockMrGreenBox)
    .forMrGreenCip(JackpotWidgetClockMrGreenBox)
    .forMrGreenCis(JackpotWidgetClockMrGreenBox)
    .apply();
